/* eslint-disable react-refresh/only-export-components */
import { useNavigate, useLoaderData } from 'react-router';
import { ContainersApiProvider } from '../../providers/ContainersApiProvider';
import { IContainer } from '../../common/ContainerSchemas';
import React, { useEffect } from 'react';
import { withAuthentication } from '../../utils/AuthenticatedLoader';
import {
  trackContainerView,
  trackNavigationError,
} from '../../utils/ClarityService';
import { isInShell } from '../../common/Shell';
import { Constants } from '../../common/Constants';

async function containersLoaderInternal(): Promise<IContainer[]> {
  try {
    const response = await ContainersApiProvider.instance.listPaginated(
      1,
      parseInt(Constants.VITE_APP_CONTAINER_PAGE_SIZE),
    );
    if (!response.containers || response.containers.length === 0) {
      throw new Error('No containers available.');
    }
    return response.containers;
  } catch (error) {
    console.error('Failed to fetch containers:', error);
    trackNavigationError();
    throw new Error(
      'Failed to fetch containers. Please check your permissions or try again later.',
    );
  }
}

export const loader = withAuthentication(containersLoaderInternal);

export const Containers: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const containers = useLoaderData() as IContainer[];
  const inShell = React.useMemo(() => isInShell(), []);

  useEffect(() => {
    // Use the containers from the loader (which should be cached)
    if (containers && containers.length > 0) {
      // Track container view
      trackContainerView();

      // Use replace to avoid adding to browser history
      navigate(
        `${inShell ? '/app/documents' : ''}/containers/${containers[0].id}`,
        { replace: true },
      );
    }
  }, [containers, navigate, inShell]);

  // Return null since this is just a redirect component
  return null;
};
